/**
 * Created by Daniela on 23/01/2017.
 */
import { Component, OnInit } from '@angular/core';

import { rastreamentosRoute, rastreamentosModuleName } from "../data.service";
import { configuracaoModuleName, configuracaoRoute } from "../../../shared/services/data.service";

@Component({
    selector: 'app-rastreamento-menu',
    template: require('./rastreamento-menu.component.html')
})
export class RastreamentoMenuComponent implements OnInit {
    rastreamentosRoute: string = rastreamentosRoute;
    configuracaoRoute: string = configuracaoRoute;
    module: any = rastreamentosModuleName;

    configuracaoModule: any = configuracaoModuleName;

    constructor() { }

    ngOnInit() {
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/shared/rastreamento-menu/rastreamento-menu.component.ts
 **/